import React from 'react';
import PropTypes from 'prop-types';
import Overlay from 'components/Overlay';

const MVPDUpsellRedirecting = ({
  backgroundUrl,
  theme,
  children,
  innerContainerChildren,
  rendered,
  backgroundClass,
  innerContainerChildrenParams,
  sharedTheme,
}) => (
  <Overlay
    backgroundClass={backgroundClass}
    backgroundUrl={backgroundUrl}
    sharedTheme={sharedTheme}
    theme={theme}
    rendered={rendered}
    innerContainerChildren={innerContainerChildren}
    innerContainerChildrenParams={innerContainerChildrenParams}
  >
    {children}
  </Overlay>
);

MVPDUpsellRedirecting.defaultProps = {
  backgroundUrl: null,
  theme: {},
  sharedTheme: {},
  children: [],
  innerContainerChildren: () => {},
  rendered: false,
  backgroundClass: '',
  innerContainerChildrenParams: {},
};

MVPDUpsellRedirecting.propTypes = {
  backgroundUrl: PropTypes.string,
  theme: PropTypes.shape({}),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  innerContainerChildren: PropTypes.func,
  rendered: PropTypes.bool,
  backgroundClass: PropTypes.string,
  innerContainerChildrenParams: PropTypes.shape({}),
  sharedTheme: PropTypes.shape({}),
};

export default MVPDUpsellRedirecting;
